export default __webpack_public_path__ + "static/media/89_mobile.aaa8b22f.jpg";